import { Directive, HostBinding, HostListener, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { ClearNotifications } from '../notification';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'a[routerLink],area[routerLink]'
})
export class RouterLinkWithHrefDirective {
  constructor(private store: Store) {}

  @HostBinding('attr.target')
  @Input()
  target: string;

  @Input()
  clearNotifications: boolean = true;

  @HostListener('click', ['$event.button', '$event.ctrlKey', '$event.metaKey', '$event.shiftKey'])
  onClick(button: number, ctrlKey: boolean, metaKey: boolean, shiftKey: boolean): void {
    if (button !== 0 || ctrlKey || metaKey || shiftKey) {
      return;
    }

    if (typeof this.target === 'string' && this.target !== '_self') {
      return;
    }

    if (this.clearNotifications) {
      this.store.dispatch(new ClearNotifications());
    }
  }
}
